import React, { useContext, useEffect } from 'react';
import { Input } from 'syngenta-digital-cropwise-react-ui-kit';

import SearchIcon from 'assets/search.svg';
import useDebounce from 'hooks/useDebounce';
import useProductSearch from 'components/ProductSideBar/helpers/useProductSearch';
import { PRODUCT_SEARCH_PAGE_SIZE } from 'helpers/globalConstants';
import { ProductListContext } from 'screens/ProductList/context/ProductListProvider';

const AddProductSearch = () => {
  const {
    setSearchedProducts,
    setLoadingProductSearch,
    setSearchText,
    searchText,
    setSearchResultPages
  } = useContext(ProductListContext);
  const timeDelay = 300;
  const filterValue = null;
  const debouncedSearchTerm = useDebounce(searchText, timeDelay);
  const debouncedTypeFilter = useDebounce(filterValue, timeDelay);

  const { filteredProducts, loading, totalPages } = useProductSearch(
    debouncedSearchTerm,
    debouncedTypeFilter,
    PRODUCT_SEARCH_PAGE_SIZE
  );

  useEffect(() => {
    setSearchedProducts(filteredProducts);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredProducts]);

  useEffect(() => {
    setLoadingProductSearch(loading);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, searchText]);

  useEffect(() => {
    setSearchResultPages(totalPages);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalPages]);

  return (
    <Input
      data-testid="product-search"
      id="product-search"
      style={{ margin: '0' }}
      type="default"
      prefix={<img alt="search" src={SearchIcon} />}
      placeholder="Enter at least three characters"
      allowClear
      size="middle"
      onChange={e => {
        setSearchText(e.target.value);
      }}
      value={!searchText.length ? '' : searchText}
    />
  );
};

export default AddProductSearch;
